(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["za-faq"] && !Shopify.designMode) return;
  try {
    
  /* Native <details name> already allows one open item; this covers browsers without it. */
  if (!customElements.get('za-faq-list')) {
    customElements.define(
      'za-faq-list',
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener(
            'toggle',
            (event) => {
              const opened = event.target;
              if (!(opened instanceof HTMLDetailsElement) || !opened.open) return;
              for (const item of this.querySelectorAll('details[open]')) {
                if (item !== opened) item.open = false;
              }
            },
            true
          );
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["za-gallery"] && !Shopify.designMode) return;
  try {
    
  /*
   * Gallery lightbox: opens the clicked photo in a dialog, moves with the
   * arrow keys or swipe, closes with Escape or the button. Without JS the grid
   * is still a grid of photos, just not clickable.
   */
  if (!customElements.get('za-gallery')) {
    customElements.define(
      'za-gallery',
      class extends HTMLElement {
        connectedCallback() {
          this.items = [...this.querySelectorAll('.za-gallery__item')];
          if (this.items.length === 0) return;

          this.index = 0;
          this.dialog = document.createElement('dialog');
          this.dialog.className = 'za-gallery__dialog';
          this.dialog.setAttribute('aria-label', this.dataset.label || 'Gallery');
          this.dialog.innerHTML = [
            '<button type="button" class="za-gallery__button za-gallery__close" data-close aria-label="Close">&#215;</button>',
            '<div class="za-gallery__stage"><img alt="" hidden></div>',
            '<div class="za-gallery__bar"><span data-caption></span>',
            '<span class="za-gallery__nav"><button type="button" class="za-gallery__button" data-prev aria-label="Previous photo">&#8592;</button>',
            '<button type="button" class="za-gallery__button" data-next aria-label="Next photo">&#8594;</button></span></div>',
          ].join('');
          this.append(this.dialog);

          this.stage = this.dialog.querySelector('.za-gallery__stage img');
          this.caption = this.dialog.querySelector('[data-caption]');

          this.items.forEach((item, i) => {
            item.addEventListener('click', () => this.open(i));
          });

          this.dialog.querySelector('[data-close]').addEventListener('click', () => this.dialog.close());
          this.dialog.querySelector('[data-prev]').addEventListener('click', () => this.show(this.index - 1));
          this.dialog.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1));
          this.dialog.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowLeft') this.show(this.index - 1);
            if (event.key === 'ArrowRight') this.show(this.index + 1);
          });

          let startX = null;
          this.dialog.addEventListener('pointerdown', (event) => {
            startX = event.clientX;
          });
          this.dialog.addEventListener('pointerup', (event) => {
            if (startX === null) return;
            const dx = event.clientX - startX;
            startX = null;
            if (Math.abs(dx) > 40) this.show(this.index + (dx < 0 ? 1 : -1));
          });
        }

        /** Only tiles that actually have a photo take part. */
        get visible() {
          return this.items.filter((item) => !item.hasAttribute('data-za-media-failed'));
        }

        open(index) {
          this.show(index);
          this.dialog.showModal();
        }

        show(target) {
          const items = this.visible;
          if (items.length === 0) return;

          const current = this.items[this.index];
          const fromVisible = items.indexOf(current);
          const base = fromVisible === -1 ? 0 : fromVisible;
          const next = ((typeof target === 'number' ? target : base) + items.length) % items.length;
          const item = items[next] || items[0];

          this.index = this.items.indexOf(item);
          const image = item.querySelector('img');
          this.stage.src = image?.currentSrc || image?.src || '';
          this.stage.hidden = this.stage.src === '';
          this.stage.alt = image?.alt || '';
          this.caption.textContent =
            (item.dataset.caption ? item.dataset.caption + ' · ' : '') +
            'Photo ' + (next + 1) + ' of ' + items.length;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["za-hero-cinematic"] && !Shopify.designMode) return;
  try {
    
  /*
   * Background video for the hero: loaded only when it is allowed and in view.
   * Phones, reduced motion and Save-Data keep the poster image only.
   */
  if (!customElements.get('za-hero-media')) {
    customElements.define(
      'za-hero-media',
      class extends HTMLElement {
        connectedCallback() {
          this.querySelector('[data-cue]')?.addEventListener('click', () => {
            const next = this.nextElementSibling || this.parentElement?.nextElementSibling;
            next?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
          });

          const src = this.dataset.videoSrc;
          if (!src) return;
          if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          if (matchMedia('(max-width: 749px)').matches) return;
          if (navigator.connection && navigator.connection.saveData) return;

          this.observer = new IntersectionObserver((entries) => {
            for (const entry of entries) {
              if (entry.isIntersecting) {
                this.start(src);
              } else {
                this.video?.pause();
              }
            }
          }, { rootMargin: '100px' });
          this.observer.observe(this);
        }

        start(src) {
          if (!this.video) {
            const video = document.createElement('video');
            video.muted = true;
            video.loop = true;
            video.playsInline = true;
            video.preload = 'metadata';
            video.setAttribute('aria-hidden', 'true');
            video.setAttribute('tabindex', '-1');
            video.src = src;
            video.addEventListener('playing', () => video.setAttribute('data-playing', 'true'), { once: true });
            // A missing or unplayable file falls back to the poster image.
            video.addEventListener('error', () => { video.remove(); this.video = null; this.observer?.disconnect(); }, { once: true });
            this.querySelector('.za-hero-cine__media').append(video);
            this.video = video;
          }
          const attempt = this.video.play();
          if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["za-media-feature"] && !Shopify.designMode) return;
  try {
    
  /* Clips play muted and looping. The button turns sound on, which also
     restarts playback so the viewer hears it from the top. */
  if (!customElements.get('za-media-clip')) {
    customElements.define(
      'za-media-clip',
      class extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video');
          this.button = this.querySelector('[data-sound]');
          if (!this.video || !this.button) return;

          // Reduced motion: hold the first frame, the button still plays it.
          if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.video.removeAttribute('autoplay');
            this.video.pause();
          }

          this.label = this.button.querySelector('.za-media-clip__sound-label');
          this.button.addEventListener('click', () => {
            const unmute = this.video.muted;
            this.video.muted = !unmute;
            this.button.setAttribute('aria-pressed', String(unmute));
            if (this.label) this.label.textContent = unmute ? 'Mute' : 'Play with sound';
            if (unmute) {
              this.video.currentTime = 0;
              this.video.play().catch(() => {});
            }
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["za-photo-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('za-photo-carousel')) {
    customElements.define(
      'za-photo-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.slides = [...this.querySelectorAll('.za-pc__slide')];
          const strip = this.querySelector('.za-pc__thumbs');
          if (strip) for (const thumb of this.querySelectorAll('.za-pc__stage .za-pc__thumb')) strip.append(thumb);
          this.thumbs = [...this.querySelectorAll('.za-pc__thumb')];
          this.status = this.querySelector('[data-status]');
          this.index = 0;

          // Photos live in Files and may be missing on a given store. Drop the
          // tile instead of leaving a broken frame. Capture phase, because
          // image error events do not bubble.
          this.addEventListener(
            'error',
            (event) => {
              if (event.target instanceof HTMLImageElement) this.dropSlide(event.target);
            },
            true
          );
          for (const image of this.querySelectorAll('.za-pc__slide img')) {
            if (image.complete && image.naturalWidth === 0) this.dropSlide(image);
          }

          if (this.slides.length < 2) return;

          this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1));
          this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1));
          for (const thumb of this.thumbs) thumb.addEventListener('click', () => this.go(Number(thumb.dataset.go)));

          const stage = this.querySelector('.za-pc__stage');
          stage.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowLeft') this.go(this.index - 1);
            if (event.key === 'ArrowRight') this.go(this.index + 1);
          });

          let startX = null;
          stage.addEventListener('pointerdown', (event) => { startX = event.clientX; });
          stage.addEventListener('pointerup', (event) => {
            if (startX === null) return;
            const dx = event.clientX - startX;
            startX = null;
            if (Math.abs(dx) > 40) this.go(this.index + (dx < 0 ? 1 : -1));
          });
        }

        /**
         * Drops a slide whose photo is missing on this store, so a 404 file
         * never leaves a broken tile behind. The whole section hides if no
         * photo survives.
         */
        dropSlide(image) {
          const slide = image.closest('.za-pc__slide');
          if (!slide) return;

          const index = this.slides.indexOf(slide);
          if (index === -1) return;

          this.slides.splice(index, 1);
          slide.remove();
          this.thumbs.splice(index, 1)[0]?.remove();
          this.thumbs.forEach((thumb, i) => {
            thumb.dataset.go = String(i);
            thumb.setAttribute('aria-label', 'Show photo ' + (i + 1));
          });

          if (this.slides.length === 0) {
            this.closest('.shopify-section')?.setAttribute('hidden', '');
            return;
          }

          this.go(Math.min(this.index, this.slides.length - 1));
        }

        go(target) {
          const count = this.slides.length;
          this.index = (target + count) % count;
          this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
          this.thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === this.index)));
          this.thumbs[this.index]?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
          if (this.status) this.status.textContent = 'Photo ' + (this.index + 1) + ' of ' + count;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["za-reels-rail"] && !Shopify.designMode) return;
  try {
    
  /*
   * Reels rail: muted preview plays only while a card is in view and hovered,
   * at most two at a time. Clicking opens the clip with sound and controls.
   */
  if (!customElements.get('za-reels-rail')) {
    customElements.define(
      'za-reels-rail',
      class extends HTMLElement {
        connectedCallback() {
          this.playing = new Set();
          this.dialog = this.querySelector('[data-dialog]');
          this.stage = this.querySelector('[data-stage]');
          this.reels = [...this.querySelectorAll('.za-reel')];
          this.allowPreview =
            !matchMedia('(prefers-reduced-motion: reduce)').matches &&
            !(navigator.connection && navigator.connection.saveData) &&
            matchMedia('(hover: hover)').matches;

          for (const reel of this.reels) {
            reel.addEventListener('click', () => this.open(reel));
            if (!this.allowPreview || !reel.dataset.reelSrc) continue;
            reel.addEventListener('pointerenter', () => this.preview(reel));
            reel.addEventListener('pointerleave', () => this.stopPreview(reel));
            reel.addEventListener('focusin', () => this.preview(reel));
            reel.addEventListener('focusout', () => this.stopPreview(reel));
          }

          this.observer = new IntersectionObserver((entries) => {
            for (const entry of entries) {
              if (!entry.isIntersecting) this.stopPreview(entry.target);
            }
          }, { threshold: 0.35 });
          for (const reel of this.reels) this.observer.observe(reel);

          this.querySelector('[data-close]')?.addEventListener('click', () => this.dialog.close());

          // Clicking outside the clip closes it as well: the dialog fills the
          // screen, so a click that lands on the dialog itself and not on the
          // stage is a click on the backdrop.
          this.dialog?.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.dialog.close();
          });

          // Stop playback on close, however it was closed, including Escape.
          this.dialog?.addEventListener('close', () => {
            this.stage.querySelector('video')?.pause();
            this.stage.replaceChildren();
          });
        }

        preview(reel) {
          if (!reel.dataset.reelSrc || reel.dataset.previewing === 'true') return;
          if (this.playing.size >= 2) return;
          const video = document.createElement('video');
          video.src = reel.dataset.reelSrc;
          video.muted = true;
          video.loop = true;
          video.playsInline = true;
          video.preload = 'metadata';
          video.setAttribute('aria-hidden', 'true');
          video.addEventListener('error', () => this.stopPreview(reel), { once: true });
          reel.querySelector('.za-reel__frame').append(video);
          reel.dataset.previewing = 'true';
          this.playing.add(reel);
          const attempt = video.play();
          if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
        }

        stopPreview(reel) {
          if (reel.dataset.previewing !== 'true') return;
          reel.querySelector('.za-reel__frame video')?.remove();
          delete reel.dataset.previewing;
          this.playing.delete(reel);
        }

        open(reel) {
          if (!reel.dataset.reelSrc || !this.dialog) return;
          this.stopPreview(reel);
          const video = document.createElement('video');
          video.src = reel.dataset.reelSrc;
          video.controls = true;
          video.autoplay = true;
          video.playsInline = true;
          video.setAttribute('title', reel.dataset.title || '');
          this.stage.replaceChildren(video);
          this.dialog.showModal();
          const attempt = video.play();
          if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["za-video-feature"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('za-video-player')) {
    customElements.define(
      'za-video-player',
      class extends HTMLElement {
        connectedCallback() {
          const button = this.querySelector('button.za-video__play');
          const poster = this.querySelector('img');
          if (!button || (!this.dataset.embedUrl && !this.dataset.videoSrc)) return;

          button.addEventListener('click', () => {
            // A click is a user gesture, so the file plays with sound.
            if (this.dataset.videoSrc) {
              const video = document.createElement('video');
              video.src = this.dataset.videoSrc;
              video.controls = true;
              video.autoplay = true;
              video.playsInline = true;
              video.setAttribute('title', this.dataset.title || '');
              video.addEventListener('error', () => { this.replaceChildren(poster, button); }, { once: true });
              this.replaceChildren(video);
              const attempt = video.play();
              if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
              return;
            }
            const iframe = document.createElement('iframe');
            iframe.src = this.dataset.embedUrl;
            iframe.title = this.dataset.title || '';
            iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
            iframe.allowFullscreen = true;
            this.replaceChildren(iframe);
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["za-video-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('za-video-gallery')) {
    customElements.define(
      'za-video-gallery',
      class extends HTMLElement {
        connectedCallback() {
          this.frame = this.querySelector('.za-vg__frame');
          this.playButton = this.frame.querySelector('[data-play]');
          this.titleEl = this.querySelector('[data-title]');
          this.captionEl = this.querySelector('[data-caption]');

          this.addEventListener('click', (event) => {
            const thumb = event.target.closest('.za-vg__thumb');
            if (thumb && this.contains(thumb)) this.select(thumb);
          });

          this.playButton.addEventListener('click', () => this.play());

          const initial = this.querySelector('.za-vg__thumb[aria-pressed="true"]') || this.querySelector('.za-vg__thumb');
          if (initial) this.select(initial, false);
        }

        select(thumb, focusPlayer = true) {
          for (const t of this.querySelectorAll('.za-vg__thumb')) t.setAttribute('aria-pressed', String(t === thumb));
          this.current = thumb;
          const hasVideo = Boolean(thumb.dataset.embed);

          this.frame.querySelector('iframe')?.remove();
          this.setPoster(thumb.dataset.poster);
          this.playButton.hidden = false;
          this.playButton.setAttribute('aria-disabled', String(!hasVideo));
          this.playButton.setAttribute('aria-label', hasVideo ? 'Play video: ' + thumb.dataset.title : 'Video coming soon: ' + thumb.dataset.title);
          this.titleEl.textContent = thumb.dataset.title;
          if (this.captionEl) this.captionEl.hidden = hasVideo;
          if (focusPlayer && window.matchMedia('(max-width: 749px)').matches) this.frame.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }

        setPoster(src) {
          let poster = this.frame.querySelector('.za-vg__poster');
          if (!src) {
            poster?.remove();
            return;
          }
          if (!poster) {
            poster = document.createElement('img');
            poster.className = 'za-vg__poster';
            poster.alt = '';
            this.frame.prepend(poster);
          }
          poster.src = src;
        }

        play() {
          const embed = this.current?.dataset.embed;
          if (!embed) return;
          const iframe = document.createElement('iframe');
          iframe.src = embed;
          iframe.title = this.current.dataset.title;
          iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
          iframe.allowFullscreen = true;
          this.playButton.hidden = true;
          this.frame.append(iframe);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
